
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactElement, reactApi } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { stringHash, comparePrimitives, safeHash, equals, createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { concat, join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { AddStocktakingUserModal } from "../Dialog/AddStocktakingUserModal.js";
import { Msg } from "./Types.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Input } from "../../Components/Input.js";
import { unwrap } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { StocktakingId__get_unwrap, FormKind as FormKind_1, FormState__getValidation } from "../../Shared/Shared.js";
import { Feature, isFeatureEnabled } from "../../FeatureFlip.js";
import { BusinessUnitSelect } from "../../Widgets/BusinessUnitSelect.js";
import { TextArea } from "../../Components/TextArea.js";
import { Checkbox } from "../../Components/Checkbox.js";
import { DatePicker } from "../../Components/DatePicker.js";
import { StocktakingTypeScope, StocktakingTypeScope__ToI18nString, StocktakingLocationScope__ToI18nString, StocktakingLocationScope } from "../../Shared/Stocktaking.js";
import { singleton as singleton_1, sortBy, toArray, contains, filter, map, tryFind, ofArray, empty as empty_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { GroupedSelectMulti, MultiSelect, Select } from "../../Components/Select.js";
import { InformationAlert } from "../../Components/Alert.js";
import { Helper_receiverTypeNameTranslation, ReceiverTypeName } from "../../Shared/User.js";
import { List_groupBy } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";
import { TableContainer } from "../../Widgets/Container.js";
import { TableControl$1, Table } from "../../Widgets/Table/Table.js";
import { ColumnDefinition$1, CellContent } from "../../Widgets/Table/Types.js";
import User_Add_Plus from "../../../public/assets/icons/User_Add_Plus.svg";
import User_Delete_Cross from "../../../public/assets/icons/User_Delete_Cross.svg";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { initEditStocktaking, initCopyStocktaking, update as update_1, initNewView } from "./State.js";
import { withoutOnboardingTourQueryParams, isStocktakingTourFormPhase } from "../../Common.js";
import { RouterModule_encodeQueryString, RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { FormContainer } from "../../Components/FormContainer.js";
import { TourGuideLocale, TourStep, TourGuide } from "../../Components/TourGuide.js";
import { Skeleton } from "../../Components/Skeleton.js";

export function StocktakingForm(props) {
    let elems_3, elems_2;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsAssignHelpingPersonModalOpen = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const setIsAssignResponsiblePersonModalOpen = patternInput_2[1];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    let isStocktakingTypeAndScopeVisible;
    const matchValue = props.EditStocktakingState;
    if (matchValue == null) {
        isStocktakingTypeAndScopeVisible = true;
    }
    else {
        const state = matchValue;
        switch (state.tag) {
            case 0: {
                isStocktakingTypeAndScopeVisible = true;
                break;
            }
            default:
                isStocktakingTypeAndScopeVisible = false;
        }
    }
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "mt-12", "max-w-5xl", "grow"])], (elems_3 = [createElement(AddStocktakingUserModal, {
        Currency: props.CustomerConfiguration.Currency,
        IsOpen: patternInput_2[0],
        OnClose: () => {
            setIsAssignResponsiblePersonModalOpen(false);
        },
        OnSave: (users) => {
            props.Dispatch(new Msg(18, [users]));
            setIsAssignResponsiblePersonModalOpen(false);
        },
        PropertyConfigurations: props.PropertyConfigurations,
        SelectedUserIds: props.Stocktaking.ResponsiblePersonIds,
        Users: props.Users,
    }), createElement(AddStocktakingUserModal, {
        Currency: props.CustomerConfiguration.Currency,
        IsOpen: patternInput_1[0],
        OnClose: () => {
            setIsAssignHelpingPersonModalOpen(false);
        },
        OnSave: (users_1) => {
            props.Dispatch(new Msg(14, [users_1]));
            setIsAssignHelpingPersonModalOpen(false);
        },
        PropertyConfigurations: props.PropertyConfigurations,
        SelectedUserIds: props.Stocktaking.HelperIds,
        Users: props.Users,
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-9", "grow"])], (elems_2 = toList(delay(() => append(singleton(createElement(Input, {
        ComponentState: componentState,
        Label: t("general.name"),
        OnChange: (arg) => {
            props.Dispatch(new Msg(5, [arg]));
        },
        TestId: "stocktaking-form-name",
        ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "name")),
        Value: props.Stocktaking.Name,
    })), delay(() => append(isFeatureEnabled(new Feature(17, [])) ? ((props.AccountSettings.BusinessUnitsEnabled && equals(props.FormKind, new FormKind_1(0, []))) ? singleton(createElement(BusinessUnitSelect, {
        BusinessUnits: props.BusinessUnits,
        FormState: props.FormState,
        OnChange: (value_2) => {
            props.Dispatch(new Msg(15, [value_2]));
        },
        SelectedBusinessUnitId: unwrap(props.Stocktaking.BusinessUnitId),
    })) : empty()) : empty(), delay(() => append(singleton(createElement(TextArea, {
        ComponentState: componentState,
        Label: t("general.description"),
        OnChange: (arg_1) => {
            props.Dispatch(new Msg(8, [arg_1]));
        },
        TestId: "stocktaking-form-description",
        ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "description")),
        Value: props.Stocktaking.Description,
    })), delay(() => append(singleton(Checkbox({
        ComponentState: componentState,
        IsChecked: props.Stocktaking.ToolsCanBeTaken,
        Label: t("stocktaking.can_be_taken_during_stocktaking"),
        OnCheck: (arg_2) => {
            props.Dispatch(new Msg(11, [arg_2]));
        },
        TestId: "stocktaking-form-can-take-during-stocktaking",
    })), delay(() => append(singleton(Checkbox({
        ComponentState: componentState,
        IsChecked: props.Stocktaking.IsScannerRequired,
        Label: t("stocktaking.scanner_required"),
        OnCheck: (arg_3) => {
            props.Dispatch(new Msg(12, [arg_3]));
        },
        TestId: "stocktaking-form-scanner-required-stocktaking",
    })), delay(() => append(singleton(createElement(DatePicker, {
        ComponentState: componentState,
        IsClearable: false,
        Label: t("general.start_date"),
        OnChange: (arg_4) => {
            props.Dispatch(new Msg(6, [arg_4]));
        },
        TestId: "stocktaking-form-startdate",
        ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "startDate")),
        Value: unwrap(props.StartDate),
    })), delay(() => append(singleton(createElement(DatePicker, {
        ComponentState: componentState,
        IsClearable: false,
        Label: t("general.end_date"),
        OnChange: (arg_5) => {
            props.Dispatch(new Msg(7, [arg_5]));
        },
        TestId: "stocktaking-form-enddate",
        ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "endDate")),
        Value: unwrap(props.EndDate),
    })), delay(() => {
        let Label_6, Value_4;
        const locationScopeOption = ofArray([{
            label: t("stocktaking.location_scope.complete"),
            value: new StocktakingLocationScope(0, []),
        }, {
            label: t("stocktaking.location_scope.storage"),
            value: new StocktakingLocationScope(1, [empty_1()]),
        }, {
            label: t(StocktakingLocationScope__ToI18nString(new StocktakingLocationScope(2, [empty_1()]))),
            value: new StocktakingLocationScope(2, [empty_1()]),
        }, {
            label: t("stocktaking.location_scope.receiver"),
            value: new StocktakingLocationScope(3, [empty_1()]),
        }]);
        return append(isStocktakingTypeAndScopeVisible ? append(singleton(createElement(Select, (Label_6 = t("stocktaking.location_scope.title"), (Value_4 = tryFind((option) => {
            const matchValue_1 = option.value;
            const matchValue_2 = props.Stocktaking.LocationScope;
            let matchResult;
            switch (matchValue_1.tag) {
                case 3: {
                    if (matchValue_2.tag === 3) {
                        matchResult = 0;
                    }
                    else {
                        matchResult = 1;
                    }
                    break;
                }
                case 2: {
                    if (matchValue_2.tag === 2) {
                        matchResult = 0;
                    }
                    else {
                        matchResult = 1;
                    }
                    break;
                }
                case 0: {
                    if (matchValue_2.tag === 0) {
                        matchResult = 0;
                    }
                    else {
                        matchResult = 1;
                    }
                    break;
                }
                default:
                    if (matchValue_2.tag === 1) {
                        matchResult = 0;
                    }
                    else {
                        matchResult = 1;
                    }
            }
            switch (matchResult) {
                case 0:
                    return true;
                default:
                    return false;
            }
        }, locationScopeOption), {
            ComponentState: componentState,
            IsClearable: false,
            Label: unwrap(Label_6),
            NoOptionsMessage: "",
            OnChange: (value_3) => {
                if (value_3 == null) {
                }
                else {
                    props.Dispatch(new Msg(9, [value_3.value]));
                }
            },
            Options: locationScopeOption,
            PlaceholderKey: "",
            TestId: "stocktaking-form-location-scope",
            ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "locationScopeOption")),
            Value: unwrap(Value_4),
        })))), delay(() => {
            let matchValue_4, Label_7, Options, Value_5;
            return append((matchValue_4 = props.Stocktaking.LocationScope, (matchValue_4.tag === 1) ? singleton(createElement(MultiSelect, (Label_7 = t("general.storage"), (Options = map((storage) => ({
                label: storage.Name,
                value: storage.Id,
            }), props.Storages), (Value_5 = filter((option_1) => contains(option_1.value, matchValue_4.fields[0], {
                Equals: equals,
                GetHashCode: (x) => (safeHash(x) | 0),
            }), map((storage_1) => ({
                label: storage_1.Name,
                value: storage_1.Id,
            }), props.Storages)), {
                ComponentState: componentState,
                IsClearable: false,
                Label: unwrap(Label_7),
                NoOptionsMessage: "",
                OnChange: (value_5) => {
                    let storageIds_1, matchValue_5;
                    if (value_5 == null) {
                    }
                    else {
                        props.Dispatch(new Msg(9, [(storageIds_1 = map((_arg_2) => _arg_2.value, ofArray(value_5)), (matchValue_5 = props.Stocktaking.LocationScope, (matchValue_5.tag === 1) ? (new StocktakingLocationScope(1, [storageIds_1])) : ((matchValue_5.tag === 2) ? (new StocktakingLocationScope(2, [storageIds_1])) : (new StocktakingLocationScope(1, [storageIds_1])))))]));
                    }
                },
                Options: Options,
                PlaceholderKey: "",
                TestId: "",
                ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "locationScope")),
                Value: Value_5,
            }))))) : ((matchValue_4.tag === 2) ? singleton(createElement(MultiSelect, (Label_7 = t("general.storage"), (Options = map((storage) => ({
                label: storage.Name,
                value: storage.Id,
            }), props.Storages), (Value_5 = filter((option_1) => contains(option_1.value, matchValue_4.fields[0], {
                Equals: equals,
                GetHashCode: (x) => (safeHash(x) | 0),
            }), map((storage_1) => ({
                label: storage_1.Name,
                value: storage_1.Id,
            }), props.Storages)), {
                ComponentState: componentState,
                IsClearable: false,
                Label: unwrap(Label_7),
                NoOptionsMessage: "",
                OnChange: (value_5) => {
                    let storageIds_1, matchValue_5;
                    if (value_5 == null) {
                    }
                    else {
                        props.Dispatch(new Msg(9, [(storageIds_1 = map((_arg_2) => _arg_2.value, ofArray(value_5)), (matchValue_5 = props.Stocktaking.LocationScope, (matchValue_5.tag === 1) ? (new StocktakingLocationScope(1, [storageIds_1])) : ((matchValue_5.tag === 2) ? (new StocktakingLocationScope(2, [storageIds_1])) : (new StocktakingLocationScope(1, [storageIds_1])))))]));
                    }
                },
                Options: Options,
                PlaceholderKey: "",
                TestId: "",
                ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "locationScope")),
                Value: Value_5,
            }))))) : ((matchValue_4.tag === 3) ? append(singleton(Checkbox({
                ComponentState: componentState,
                IsChecked: props.Stocktaking.IsSelfInventory,
                Label: t("stocktaking.self_inventory"),
                OnCheck: (arg_6) => {
                    props.Dispatch(new Msg(13, [arg_6]));
                },
                TestId: "stocktaking-form-self-inventory",
            })), delay(() => append(props.Stocktaking.IsSelfInventory ? singleton(createElement(InformationAlert, {
                Label: "stocktaking.self_inventory_description",
            })) : empty(), delay(() => {
                let elems, Label_9, Options_1, Value_6;
                return singleton(reactElement("div", createObj(ofArray([["data-test-id", "stocktaking-form-receiver-select"], (elems = [createElement(GroupedSelectMulti, (Label_9 = t("general.receiver"), (Options_1 = map((tupledArg) => {
                    const receiverType = tupledArg[0];
                    const receivers_1 = toArray(sortBy((receiver_2) => receiver_2.label.toLowerCase(), map((receiver_1) => {
                        const matchValue_6 = receiver_1.LocationName;
                        if (matchValue_6 != null) {
                            const locationName = matchValue_6;
                            if (equals(receiverType, new ReceiverTypeName(4, []))) {
                                return {
                                    label: concat(locationName, " - ", ...receiver_1.Name),
                                    value: receiver_1.Id,
                                };
                            }
                            else {
                                return {
                                    label: concat(receiver_1.Name, " - ", ...locationName),
                                    value: receiver_1.Id,
                                };
                            }
                        }
                        else {
                            return {
                                label: receiver_1.Name,
                                value: receiver_1.Id,
                            };
                        }
                    }, tupledArg[1]), {
                        Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
                    }));
                    return {
                        label: Helper_receiverTypeNameTranslation(t, receiverType),
                        options: receivers_1,
                    };
                }, List_groupBy((receiver) => receiver.ReceiverType, props.Receiver, {
                    Equals: equals,
                    GetHashCode: (x_1) => (safeHash(x_1) | 0),
                })), (Value_6 = filter((option_3) => contains(option_3.value, matchValue_4.fields[0], {
                    Equals: (x_3, y_3) => (x_3 === y_3),
                    GetHashCode: (x_3) => (stringHash(x_3) | 0),
                }), map((receiver_3) => ({
                    label: receiver_3.Name,
                    value: receiver_3.Id,
                }), props.Receiver)), {
                    ComponentState: componentState,
                    IsClearable: false,
                    Label: unwrap(Label_9),
                    NoOptionsMessage: "",
                    OnChange: (value_10) => {
                        if (value_10 == null) {
                        }
                        else {
                            props.Dispatch(new Msg(9, [new StocktakingLocationScope(3, [map((option_2) => option_2.value, ofArray(value_10))])]));
                        }
                    },
                    Options: Options_1,
                    PlaceholderKey: "",
                    TestId: "",
                    ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "locationScope")),
                    Value: Value_6,
                }))))], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
            })))) : (empty())))), delay(() => {
                let Label_10, Value_7;
                const typeScopeOptions = ofArray([{
                    label: t(StocktakingTypeScope__ToI18nString(new StocktakingTypeScope(0, []))),
                    value: new StocktakingTypeScope(0, []),
                }, {
                    label: t(StocktakingTypeScope__ToI18nString(new StocktakingTypeScope(1, []))),
                    value: new StocktakingTypeScope(1, []),
                }, {
                    label: t(StocktakingTypeScope__ToI18nString(new StocktakingTypeScope(2, []))),
                    value: new StocktakingTypeScope(2, []),
                }]);
                return singleton(createElement(MultiSelect, (Label_10 = t("stocktaking.type_scope.title"), (Value_7 = filter((option_4) => contains(option_4.value, props.Stocktaking.TypeScope, {
                    Equals: equals,
                    GetHashCode: (x_4) => (safeHash(x_4) | 0),
                }), typeScopeOptions), {
                    ComponentState: componentState,
                    IsClearable: false,
                    Label: unwrap(Label_10),
                    NoOptionsMessage: "",
                    OnChange: (value_14) => {
                        if (value_14 == null) {
                        }
                        else {
                            props.Dispatch(new Msg(10, [map((value_16) => value_16.value, ofArray(value_14))]));
                        }
                    },
                    Options: typeScopeOptions,
                    PlaceholderKey: "",
                    TestId: "",
                    ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "typeScope")),
                    Value: Value_7,
                }))));
            }));
        })) : empty(), delay(() => {
            let elems_1, Title, TableRows, Options_2, Title_1, TableRows_1, Options_3;
            return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "grow", "gap-3"])], (elems_1 = [createElement(TableContainer, (Title = t("stocktaking.responsible_person"), {
                Content: createElement(Table, (TableRows = toArray(filter((user) => contains(user.Id, props.Stocktaking.ResponsiblePersonIds, {
                    Equals: (x_5, y_5) => (x_5 === y_5),
                    GetHashCode: (x_5) => (stringHash(x_5) | 0),
                }), props.Users)), (Options_2 = {
                    BorderStyle: "full",
                    CSVDownload: false,
                    ConfigurableColumns: false,
                    CustomTableFilters: false,
                    DefaultSortColumn: ["name", "asc"],
                    Fullscreen: false,
                    GlobalSearch: false,
                    RowSelection: "multiRow",
                    SaveTableConfiguration: false,
                }, {
                    ColumnDefinitions: [new ColumnDefinition$1("name", "", t("general.name"), (dto) => (new CellContent(0, [dto.Name])), "text", "text"), new ColumnDefinition$1("department", "", t("user.department"), (dto_1) => (new CellContent(0, [dto_1.Department])), "text", "text")],
                    Controls: ofArray([new TableControl$1(t("stocktaking.add"), User_Add_Plus(), (_arg_3) => {
                        setIsAssignResponsiblePersonModalOpen(true);
                    }, false, false, "stocktaking-form-table-add"), new TableControl$1(t("stocktaking.remove"), User_Delete_Cross(), (users_2) => {
                        props.Dispatch(new Msg(17, [users_2]));
                        setIsAssignResponsiblePersonModalOpen(false);
                    }, true, false, "stocktaking-form-table-remove")]),
                    Options: Options_2,
                    TableKey: "not-defined-table",
                    TableRows: TableRows,
                }))),
                Title: unwrap(Title),
            })), createElement(TableContainer, (Title_1 = t("stocktaking.stocktaking_helper"), {
                Content: createElement(Table, (TableRows_1 = toArray(filter((user_1) => contains(user_1.Id, props.Stocktaking.HelperIds, {
                    Equals: (x_6, y_6) => (x_6 === y_6),
                    GetHashCode: (x_6) => (stringHash(x_6) | 0),
                }), props.Users)), (Options_3 = {
                    BorderStyle: "full",
                    CSVDownload: false,
                    ConfigurableColumns: false,
                    CustomTableFilters: false,
                    DefaultSortColumn: ["name", "asc"],
                    Fullscreen: false,
                    GlobalSearch: false,
                    RowSelection: "multiRow",
                    SaveTableConfiguration: false,
                }, {
                    ColumnDefinitions: [new ColumnDefinition$1("name", "", t("general.name"), (dto_2) => (new CellContent(0, [dto_2.Name])), "text", "text"), new ColumnDefinition$1("department", "", t("user.department"), (dto_3) => (new CellContent(0, [dto_3.Department])), "text", "text")],
                    Controls: ofArray([new TableControl$1(t("stocktaking.add"), User_Add_Plus(), (_arg_4) => {
                        setIsAssignHelpingPersonModalOpen(true);
                    }, false, false, "stocktaking-form-add-to-table"), new TableControl$1(t("stocktaking.remove"), User_Delete_Cross(), (users_3) => {
                        props.Dispatch(new Msg(16, [users_3]));
                        setIsAssignResponsiblePersonModalOpen(false);
                    }, true, false, "stocktaking-form-remove-from-table")]),
                    Options: Options_3,
                    TableKey: "not-defined-table",
                    TableRows: TableRows_1,
                }))),
                Title: unwrap(Title_1),
            }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
        }));
    })))))))))))))))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

export function NewFormView(props) {
    let elems;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(initNewView, update_1, (_arg, _arg_1) => {
    }), undefined, undefined);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const setStocktakingFormTourDismissed = patternInput_2[1];
    const showStocktakingFormTour = (isFeatureEnabled(new Feature(4, [])) && isStocktakingTourFormPhase()) && !patternInput_2[0];
    const clearStocktakingFormTourFromUrl = () => {
        RouterModule_nav(ofArray(["stocktaking", "new" + RouterModule_encodeQueryString(withoutOnboardingTourQueryParams())]), 1, 1);
    };
    const matchValue = state_1.StocktakingForm;
    const matchValue_1 = state_1.Users;
    const matchValue_2 = state_1.Storages;
    const matchValue_3 = state_1.Receiver;
    const matchValue_4 = state_1.PropertyConfigurations;
    const matchValue_5 = state_1.BusinessUnits;
    const matchValue_6 = state_1.AccountSettings;
    let matchResult, accountSettings, businessUnits, propertyConfigurations, receiver, stocktaking, storages, users;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_3.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_4.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_5.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_6.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        accountSettings = matchValue_6.fields[0];
        businessUnits = matchValue_5.fields[0];
        propertyConfigurations = matchValue_4.fields[0];
        receiver = matchValue_3.fields[0];
        stocktaking = matchValue.fields[0];
        storages = matchValue_2.fields[0];
        users = matchValue_1.fields[0];
    }
    switch (matchResult) {
        case 0:
            return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full", "flex", "flex-col"])], (elems = toList(delay(() => {
                let Header;
                return append(singleton(createElement(FormContainer, (Header = t("stocktaking.create_new_stocktaking"), {
                    Children: singleton_1(createElement(StocktakingForm, {
                        AccountSettings: accountSettings,
                        BusinessUnits: businessUnits,
                        CustomerConfiguration: props.CustomerConfiguration,
                        Dispatch: dispatch,
                        EditStocktakingState: unwrap(state_1.EditStocktakingState),
                        EndDate: unwrap(state_1.EndDate),
                        FormKind: state_1.FormKind,
                        FormState: state_1.FormState,
                        PropertyConfigurations: propertyConfigurations,
                        Receiver: receiver,
                        StartDate: unwrap(state_1.StartDate),
                        Stocktaking: stocktaking,
                        Storages: storages,
                        Users: users,
                    })),
                    Header: Header,
                    OnBack: () => {
                        RouterModule_nav(ofArray(["stocktaking"]), 1, 1);
                    },
                    OnSave: () => {
                        dispatch(new Msg(2, []));
                    },
                }))), delay(() => {
                    let Steps;
                    return showStocktakingFormTour ? singleton(createElement(TourGuide, (Steps = ofArray([new TourStep("[data-test-id=\'stocktaking-form-name\']", t("onboarding.tour.stocktaking_tour_form_name_title"), reactElement("div", {
                        children: t("onboarding.tour.stocktaking_tour_form_name_content"),
                    }), "bottom", true), new TourStep("[data-test-id=\'stocktaking-form-startdate\']", t("onboarding.tour.stocktaking_tour_form_start_date_title"), reactElement("div", {
                        children: t("onboarding.tour.stocktaking_tour_form_start_date_content"),
                    }), "bottom", true), new TourStep("[data-test-id=\'stocktaking-form-enddate\']", t("onboarding.tour.stocktaking_tour_form_end_date_title"), reactElement("div", {
                        children: t("onboarding.tour.stocktaking_tour_form_end_date_content"),
                    }), "bottom", true), new TourStep("[data-test-id=\'stocktaking-form-location-scope\']", t("onboarding.tour.stocktaking_tour_form_location_scope_title"), reactElement("div", {
                        children: t("onboarding.tour.stocktaking_tour_form_location_scope_content"),
                    }), "bottom", true), new TourStep("[data-test-id=\'stocktaking-form-receiver-select\']", t("onboarding.tour.stocktaking_tour_form_receiver_select_title"), reactElement("div", {
                        children: t("onboarding.tour.stocktaking_tour_form_receiver_select_content"),
                    }), "bottom", true), new TourStep("[data-test-id=\'stocktaking-form-self-inventory\']", t("onboarding.tour.stocktaking_tour_form_self_inventory_title"), reactElement("div", {
                        children: t("onboarding.tour.stocktaking_tour_form_self_inventory_content"),
                    }), "bottom", true)]), {
                        IsRunning: true,
                        Locale: new TourGuideLocale(t("onboarding.tour.joyride_back"), t("onboarding.tour.joyride_close"), t("onboarding.tour.joyride_last"), t("onboarding.tour.joyride_next"), t("onboarding.tour.joyride_next_with_progress"), t("onboarding.tour.joyride_open"), t("onboarding.tour.joyride_skip")),
                        OnFinish: () => {
                            setStocktakingFormTourDismissed(true);
                            clearStocktakingFormTourFromUrl();
                        },
                        OnSkip: () => {
                            setStocktakingFormTourDismissed(true);
                            clearStocktakingFormTourFromUrl();
                        },
                        ScrollFirstStep: true,
                        Steps: Steps,
                    }))) : empty();
                }));
            })), ["children", reactApi.Children.toArray(Array.from(elems))])])));
        default:
            return createElement(Skeleton, {
                Variant: "detail",
            });
    }
}

export function CopyFormView(props) {
    let Header;
    const patternInput = useTranslation();
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(initCopyStocktaking, update_1, (_arg, _arg_1) => {
    }), props.StocktakingId, undefined);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const matchValue = state_1.StocktakingForm;
    const matchValue_1 = state_1.Users;
    const matchValue_2 = state_1.Storages;
    const matchValue_3 = state_1.Receiver;
    const matchValue_4 = state_1.PropertyConfigurations;
    const matchValue_5 = state_1.BusinessUnits;
    const matchValue_6 = state_1.AccountSettings;
    let matchResult, accountSettings, businessUnits, propertyConfigurations, receiver, stocktaking, storages, users;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_3.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_4.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_5.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_6.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        accountSettings = matchValue_6.fields[0];
        businessUnits = matchValue_5.fields[0];
        propertyConfigurations = matchValue_4.fields[0];
        receiver = matchValue_3.fields[0];
        stocktaking = matchValue.fields[0];
        storages = matchValue_2.fields[0];
        users = matchValue_1.fields[0];
    }
    switch (matchResult) {
        case 0:
            return createElement(FormContainer, (Header = patternInput[0]("stocktaking.create_new_stocktaking"), {
                Children: singleton_1(createElement(StocktakingForm, {
                    AccountSettings: accountSettings,
                    BusinessUnits: businessUnits,
                    CustomerConfiguration: props.CustomerConfiguration,
                    Dispatch: dispatch,
                    EditStocktakingState: unwrap(state_1.EditStocktakingState),
                    EndDate: unwrap(state_1.EndDate),
                    FormKind: state_1.FormKind,
                    FormState: state_1.FormState,
                    PropertyConfigurations: propertyConfigurations,
                    Receiver: receiver,
                    StartDate: unwrap(state_1.StartDate),
                    Stocktaking: stocktaking,
                    Storages: storages,
                    Users: users,
                })),
                Header: Header,
                OnBack: () => {
                    RouterModule_nav(ofArray(["stocktaking", StocktakingId__get_unwrap(props.StocktakingId)]), 1, 1);
                },
                OnSave: () => {
                    dispatch(new Msg(2, []));
                },
            }));
        default:
            return createElement(Skeleton, {
                Variant: "detail",
            });
    }
}

export function EditFormView(props) {
    let Header;
    const patternInput = useTranslation();
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(initEditStocktaking, update_1, (_arg, _arg_1) => {
    }), props.StocktakingId, undefined);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const matchValue = state_1.StocktakingForm;
    const matchValue_1 = state_1.Users;
    const matchValue_2 = state_1.Storages;
    const matchValue_3 = state_1.Receiver;
    const matchValue_4 = state_1.PropertyConfigurations;
    const matchValue_5 = state_1.BusinessUnits;
    const matchValue_6 = state_1.AccountSettings;
    let matchResult, accountSettings, businessUnits, propertyConfigurations, receiver, stocktaking, storages, users;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_3.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_4.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_5.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_6.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        accountSettings = matchValue_6.fields[0];
        businessUnits = matchValue_5.fields[0];
        propertyConfigurations = matchValue_4.fields[0];
        receiver = matchValue_3.fields[0];
        stocktaking = matchValue.fields[0];
        storages = matchValue_2.fields[0];
        users = matchValue_1.fields[0];
    }
    switch (matchResult) {
        case 0:
            return createElement(FormContainer, (Header = patternInput[0]("stocktaking.edit_stocktaking"), {
                Children: singleton_1(createElement(StocktakingForm, {
                    AccountSettings: accountSettings,
                    BusinessUnits: businessUnits,
                    CustomerConfiguration: props.CustomerConfiguration,
                    Dispatch: dispatch,
                    EditStocktakingState: unwrap(state_1.EditStocktakingState),
                    EndDate: unwrap(state_1.EndDate),
                    FormKind: state_1.FormKind,
                    FormState: state_1.FormState,
                    PropertyConfigurations: propertyConfigurations,
                    Receiver: receiver,
                    StartDate: unwrap(state_1.StartDate),
                    Stocktaking: stocktaking,
                    Storages: storages,
                    Users: users,
                })),
                Header: Header,
                OnBack: () => {
                    RouterModule_nav(ofArray(["stocktaking", StocktakingId__get_unwrap(props.StocktakingId)]), 1, 1);
                },
                OnSave: () => {
                    dispatch(new Msg(3, []));
                },
            }));
        default:
            return createElement(Skeleton, {
                Variant: "normal",
            });
    }
}

